module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/graph-6db1457569553fb0befa86371d8cff61.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/graph.svg
// module id = 621
// module chunks = 0